import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { AccordionClass } from ".";

interface ExhibitionsAccordionProps {
  exhibitionsCalculated: string | null;
  t: (key: string) => string;
}

export function ExhibitionsAccordion({
  exhibitionsCalculated,
  t,
}: ExhibitionsAccordionProps) {
  if (!exhibitionsCalculated) return null;

  return (
    <AccordionItem value="expositions">
      <AccordionTrigger>
        {t("singleArtworkSubtitleExhibition")}
      </AccordionTrigger>
      <AccordionContent>
        <div
          dangerouslySetInnerHTML={{
            __html: exhibitionsCalculated,
          }}
          className={AccordionClass}
        />
      </AccordionContent>
    </AccordionItem>
  );
}
